
import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What industries do you primarily serve?",
    answer: "We serve a wide range of industries including healthcare, finance, e-commerce, manufacturing, and education. Our solutions are customizable to meet the specific needs of any business sector."
  },
  {
    question: "How long does it typically take to implement your AI solutions?",
    answer: "Implementation timelines vary based on the complexity of the project. Simple integrations can be completed in 2-4 weeks, while more comprehensive solutions might take 2-3 months. We provide detailed timelines during our initial consultation."
  },
  {
    question: "Do you offer ongoing support after project completion?",
    answer: "Yes, we offer various support packages to ensure your solution continues to perform optimally. These include regular maintenance, updates, and technical support. We can tailor a support plan to fit your specific needs and budget."
  },
  {
    question: "What makes your AI solutions different from others in the market?",
    answer: "Our AI solutions are built with a focus on practical business outcomes rather than just cutting-edge technology. We combine deep industry knowledge with technical expertise to develop solutions that address specific business challenges and provide measurable ROI."
  },
  {
    question: "Can your solutions integrate with our existing systems?",
    answer: "Absolutely. Our solutions are designed with interoperability in mind. We have experience integrating with a wide range of existing systems, from legacy software to modern cloud platforms. Our team will assess your current infrastructure to ensure seamless integration."
  },
  {
    question: "How do you handle data security and privacy concerns?",
    answer: "Data security is a top priority for us. We implement industry-standard security protocols and comply with relevant regulations like GDPR and CCPA. All data is encrypted both in transit and at rest, and we provide detailed information about our security measures during project onboarding."
  }
];

const Faq = () => {
  const [activeItem, setActiveItem] = useState<string | null>("item-0");

  return (
    <section className="py-20 bg-background/20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 gradient-text">Frequently Asked Questions</h2>
        <p className="text-center text-gray-400 mb-12 max-w-2xl mx-auto">
          Get answers to common questions about our services, processes, and solutions
        </p>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4" value={activeItem} onValueChange={setActiveItem}>
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-primary/20 rounded-lg overflow-hidden bg-maitech-800/50 backdrop-blur-sm"
              >
                <AccordionTrigger className="text-white hover:text-primary px-6 text-left hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 px-6 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-400 mb-4">Still have questions?</p>
          <div className="flex justify-center space-x-4">
            <a href="/contact" className="text-primary hover:underline">Contact Us</a>
            <span className="text-gray-600">|</span>
            <a href="/resources" className="text-primary hover:underline">View Resources</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
